import { getParentModule, mapPermissionToSchema, getModulePermission } from 'utils/helpers';
import { MODULES } from 'config';
import { useSelector } from 'react-redux';
import { PERMISSION_LIST } from 'config';

const usePermission = () => {
  const { permission } = useSelector((state) => state.auth);

  const currentPermission = mapPermissionToSchema(permission);

  const hasDataAuditReportModulePermision = getModulePermission(currentPermission, MODULES.DATA_AUDIT_REPORT);
  const hasProfessionalModulePermission = getModulePermission(currentPermission, MODULES.PROFESSIONAL);
  const hasAncillaryModulePermission = getModulePermission(currentPermission, MODULES.ANCILLARY);
  const hasFacilityModulePermission = getModulePermission(currentPermission, MODULES.FACILITY);
  const allDataAuditReportPermission = currentPermission[MODULES.DATA_AUDIT_REPORT];
  const allProfessionalPermission = currentPermission[MODULES.PROFESSIONAL];
  const allAncillaryPermission = currentPermission[MODULES.ANCILLARY];
  const allFacilityPermission = currentPermission[MODULES.FACILITY];

  const getChildPermission = (childPermissionKey) => {
    const parentModule = getParentModule(childPermissionKey);
    if (parentModule) {
      return currentPermission[parentModule][childPermissionKey];
    }
    return false;
  };

  const getRoutePermission = (route) => {
    switch (route) {
      /*DATA AUDIT ROUTE*/
      case '/payer-scorecard':
        return allDataAuditReportPermission?.[PERMISSION_LIST.PAYER_SCORECARD] || false;
      case '/report-summary':
        return allDataAuditReportPermission?.[PERMISSION_LIST.REPORT_SUMMARY] || false;
      case '/procedure-cost-by-hospital':
        return allDataAuditReportPermission?.[PERMISSION_LIST.PROCEDURE_COST_BY_HOSPITAL] || false;
      case '/drg-ref-table':
        return allDataAuditReportPermission?.[PERMISSION_LIST.DRG_COUNTS_BY_PAYER_AND_HOSPITAL] || false;

      /*COMMON ROUTE*/
      case '/competitive-landscape':
        return (
          allProfessionalPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE] ||
          allAncillaryPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE] ||
          allFacilityPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE]
        );
      case '/':
        return (
          allProfessionalPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE] ||
          allAncillaryPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE] ||
          allFacilityPermission?.[PERMISSION_LIST.COMPETITIVE_LANDSCAPE]
        );

      /*FACILITY ROUTE*/
      case '/top-drg':
        return allFacilityPermission?.[PERMISSION_LIST.TOP_DRGS_OVERVIEW] || false;
      case '/top-cpt':
        return allFacilityPermission?.[PERMISSION_LIST.TOP_CPTS_OVERVIEW] || false;
      case '/payer-price-comparison-CPT-HCPCS':
        return allFacilityPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS] || false;
      case '/payers-price-compare-drg':
        return allFacilityPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG] || false;
      case '/payers-price-compare-apc':
        return allFacilityPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC] || false;
      case '/filtered-drg-list':
        return allFacilityPermission?.[PERMISSION_LIST.FILTERED_DRG_LIST] || false;
      case '/provider-CPT-HCPCS-data':
        return allFacilityPermission?.[PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA] || false;
      case '/historical-requests':
        return allFacilityPermission?.[PERMISSION_LIST.HISTORICAL_REQUESTS] || false;

      /*ANCILLARY ROUTE*/
      case '/top-drg':
        return allAncillaryPermission?.[PERMISSION_LIST.TOP_DRGS_OVERVIEW] || false;
      case '/top-cpt':
        return allAncillaryPermission?.[PERMISSION_LIST.TOP_CPTS_OVERVIEW] || false;
      case '/payer-price-comparison-CPT-HCPCS':
        return allAncillaryPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_CPT_HCPCS] || false;
      case '/payers-price-compare-drg':
        return allAncillaryPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_DRG] || false;
      case '/payers-price-compare-apc':
        return allAncillaryPermission?.[PERMISSION_LIST.PAYER_PRICE_COMPARISON_APC] || false;
      case '/filtered-drg-list':
        return allAncillaryPermission?.[PERMISSION_LIST.FILTERED_DRG_LIST] || false;
      case '/provider-CPT-HCPCS-data':
        return allAncillaryPermission?.[PERMISSION_LIST.PROVIDER_CPT_HCPCS_DATA] || false;
      case '/historical-requests':
        return allAncillaryPermission?.[PERMISSION_LIST.HISTORICAL_REQUESTS] || false;

      default:
        return false;
    }
  };

  return {
    currentPermission,
    allDataAuditReportPermission,
    allProfessionalPermission,
    getRoutePermission,
    getChildPermission,
    hasDataAuditReportModulePermision,
    hasProfessionalModulePermission,
    hasAncillaryModulePermission,
    hasFacilityModulePermission,
    allAncillaryPermission,
    allFacilityPermission
  };
};

export default usePermission;
